module.exports = __webpack_public_path__ + "img/word.89df00c2.png";